import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "absolute right-0 bottom-0 border border-dashed border-amff-teal",
  style: {"left":"6.7%","top":"6.19%"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["relative", {
      'mt-14 ml-6': _ctx.isRotated && _ctx.rotateDirection === 'left',
      'mt-8 ml-5': _ctx.isRotated && _ctx.rotateDirection === 'right',
    }],
    style: {"padding-bottom":"59.14%"}
  }, [
    _hoisted_1,
    _createVNode("div", {
      class: "absolute top-0 left-0",
      style: [{"right":"6.7%","bottom":"6.19%"}, 
        !_ctx.isRotated
          ? ''
          : _ctx.rotateDirection === 'left'
          ? 'transform: rotate(-7deg); transform-origin: 50% 20%'
          : 'transform: rotate(10deg); transform-origin: 35% 70%'
      ]
    }, [
      _createVNode("img", {
        class: "w-full h-full object-fit-cover",
        src: _ctx.imageSrc,
        srcset: _ctx.imageSrcset
      }, null, 8, ["src", "srcset"])
    ], 4)
  ], 2))
}